import * as React from 'react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Field, Input } from '@/components/ui/input';
import { authApi } from '@/lib/api/endpoints';
import { useAuth, useMe } from '@/lib/auth';
import { userMessage } from '@/lib/api/errors';

export function PasswordChangePage() {
  const me = useMe();
  const { refreshMe } = useAuth();
  const [current, setCurrent] = React.useState('');
  const [next, setNext] = React.useState('');
  const [confirm, setConfirm] = React.useState('');
  const [busy, setBusy] = React.useState(false);
  const [error, setError] = React.useState('');
  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (next.length < 8) { setError('Use at least 8 characters.'); return; }
    if (next !== confirm) { setError('The new passwords do not match.'); return; }
    setBusy(true); setError('');
    try {
      await authApi.changePassword(current, next);
      refreshMe();
      setCurrent(''); setNext(''); setConfirm('');
      toast.success('Password changed.');
    } catch (err) {
      setError(userMessage(err, 'Could not change password.'));
    } finally { setBusy(false); }
  }
  return <div className="mx-auto max-w-xl space-y-6">
    <div><p className="text-sm font-semibold text-primary-ink">Account security</p><h1 className="mt-1 text-3xl font-extrabold">Change password</h1>
      <p className="mt-2 text-muted-foreground">{me.must_change_password ? 'Your administrator reset your password. Change it to continue.' : 'Choose a new password for your account.'}</p></div>
    <form onSubmit={submit} className="space-y-4 rounded-2xl border bg-card p-6 shadow-sm">
      <Field label="Current password" htmlFor="current-password"><Input id="current-password" type="password" autoComplete="current-password" required value={current} onChange={e => setCurrent(e.target.value)} /></Field>
      <Field label="New password" htmlFor="new-password" hint="At least 8 characters."><Input id="new-password" type="password" autoComplete="new-password" minLength={8} required value={next} onChange={e => setNext(e.target.value)} /></Field>
      <Field label="Confirm new password" htmlFor="confirm-password"><Input id="confirm-password" type="password" autoComplete="new-password" required value={confirm} onChange={e => setConfirm(e.target.value)} /></Field>
      {error && <p role="alert" className="text-sm font-medium text-destructive">{error}</p>}
      <Button type="submit" loading={busy}>Save new password</Button>
    </form>
  </div>;
}
